'use strict';

function adminUserService($http, $interpolate, upload) {
  var baseURL = '/api/core/user-admin/';
  var commitCsvImportURL = '/api/core/user-admin/import_managers/';
  var csvImportURL = '/api/core/csv-parser/';
  var singleURL = $interpolate('/api/core/user-admin/{{id}}/');


  return {
    list: list,
    create: create,
    update: update,
    patch: patch,
    destroy: destroy,
    commitCsvImport: commitCsvImport,
    csvImport: csvImport
  };

  function list() {
    return $http.get(baseURL);
  }

  function create(user) {
    return $http.post(baseURL, user);
  }

  function update(id, user) {
    return $http.put(singleURL({id : id}), user);
  }

  function patch(id, user) {
    return $http({ url: singleURL({ id: id }), method: 'PATCH', data: user });
  }

  function destroy(id) {
    return $http.delete(singleURL({ id: id }));
  }

  function csvImport(file) {
    return upload({ url: csvImportURL, method: 'POST', data: { file: file } });
  }

  function commitCsvImport(users) {
    return $http.post(commitCsvImportURL, users);
  }


}

module.exports = adminUserService;




/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/users/service/index.js
 ** module id = 140
 ** module chunks = 0
 **/